import React, { useRef, useState } from 'react';
import { notify } from '../../functions/tostify';
import { ExcelSignupSchool } from '../../services/signup-school';
import FetchLoading from '../FetchLoading';
import { ToastContainer } from 'react-toastify';

function SchoolSignup() {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null)

    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("No file selected");
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef(null);

    const handleFile = (selectedFile) => {
        if (selectedFile && selectedFile.name.endsWith(".xlsx")) {
            setFile(selectedFile);
            setFileName(selectedFile.name);
        } else {
            notify("فقط فایل با فرمت xlsx پذیرفته است", "error")
            setFile(null);
            setFileName("Invalid file");
        }
    };

    const handleFileChange = (e) => {
        handleFile(e.target.files[0]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        handleFile(droppedFile);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            notify("فایل خود را انتخاب کنید", "error")
            return;
        }

        setLoading(true)
        setUploading(true);
        ExcelSignupSchool({file: file})
            .then((response) => {
                notify("اطلاعات ارسال شد منتظر نتیجه باشید!", "success")
                setResult(response.data.body)
                console.log(response)
            })
            .catch((error) => {
                if ((error.response.status === 403 || error.response.status === 401))
                    notify("دوباره وارد شوید", "error")
                if (error.response.status === 422 && (error.response.data === "wrong code" || error.response.data === "Validation error." || error.response.data === "Invalid Credentials"))
                    notify("نمی دونم چی شده", "error")
                else
                    notify("ارتباط با سرور برقرار نشد. لطفا دقایقی دیگر تلاش کنید.", "error")
            }).finally(() => {
            setUploading(false);
            setLoading(false);
        })
    };

    return (
        <div dir="rtl" className="w-full fixed font-medium font-mediumFA z-[8] h-full p-8 flex flex-col justify-center items-center">
            {loading && <FetchLoading/>}
            <ToastContainer toastStyle={{borderRadius: 'min(1vw,2vh)'}} rtl/>
            {result ?
                <div className="w-[90%] text-center min-h-[90%] p-4 bg-[#ffffffeb] rounded-xl">
                    <div className="text-3xl m-4 text-[#265e26]">
                        {result['school'].length > 0 ?
                            <div className="text-[#bb2d3b]">
                                ثبت نام انجام نشد چون
                                {result['school'].map((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </div>
                            :
                            "ثبت نام انجام شد"
                        }
                    </div>
                    {
                        result['classroom'].length > 0 && <div>
                        <h2 className="text-xl m-2">
                            {result['school'].length > 0 ?
                                "کلاس هایی که ثبت نامشون انجام نخواهد شد چون:"
                                :
                                "کلاس هایی که ثبت نامشون انجام نشده:"
                            }
                        </h2>
                            {result['classroom'].map((item, index) => (
                                <div key={index}>{item}</div>
                            ))}
                        </div>
                    }
                    {
                        result['student'].length > 0 && <div>
                            <h2 className="text-xl m-2">
                                {result['school'].length > 0 ?
                                    'دانش آموزانی که ثبت نامشون انجام نخواهد شد چون:'
                                    :
                                    'دانش آموزانی که ثبت نامشون انجام نشده:'
                                }
                            </h2>
                            {result['student'].map((item, index) => (
                                <div key={index}>{item}</div>
                            ))}
                        </div>
                    }
                </div>
                :
                <form onSubmit={handleSubmit}
                      className="text-center md:w-[50%] w-[90%] h-[50%] m-2 text-white bg-[#001037] rounded-2xl flex flex-col justify-center items-center">
                    {/* Drop Zone */}
                    <div
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        className="border-dashed border-2 p-2 border-[#ccc] rounded-xl w-[70%] h-[50%] flex justify-center items-center flex-col m-8 cursor-pointer"
                        onClick={triggerFileInput}
                    >
                        <p>فایل اکسل خود را با فرمت xlsx اینجا بندازید</p>
                        <p>یا اینجا کلیک کنید</p>
                        <p className="text-[#aaaaaa] italic">{fileName}</p>
                        <input
                            type="file"
                            accept=".xlsx"
                            ref={fileInputRef}
                            className="hidden"
                            onChange={handleFileChange}
                        />
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={uploading}
                        className="px-16 py-2 m-4 bg-[#4f46e5] rounded-md cursor-pointer"
                    >
                        {uploading ? "در حال بارگذاری..." : "بارگذاری"}
                    </button>
                </form>
            }
        </div>
    );
}

export default SchoolSignup;